import script from "./newquotestep2-5.vue?vue&type=script&setup=true&lang=js"
export * from "./newquotestep2-5.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__